export default {
    methods :{
        getReadableDate(date) { 
            console.log(date);
            var returnedDate = date;
            if(date !== undefined) {
                if(date.includes('0001')) returnedDate = "";
                if(date.includes("T")) {
                    var arr = date.split("T");
                    returnedDate = arr[0];
                    if(returnedDate.includes('0001')) returnedDate = "";
                }
            }
            return returnedDate;
        }
    }
}